import React, {Fragment} from 'react';
import {Button, Col, ControlLabel, Form, FormControl, FormGroup, Glyphicon, HelpBlock, Table} from 'react-bootstrap';
import EditPage from '../EditPage';
import Select from 'react-select';
import validator from 'validator';
import GreenLeafApi from '../utils/GreenLeafApi';
import CreateContactModal from '../teams/CreateContactModal';
import ErrorComponent from '../ErrorComponent';

class CreateEngagementPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sponsor: null,
      coach: '',
      sponsorId: '',
      start_date: null,
      end_date: null,
      teams: [],
      goals: [],
      recommendations: [],
      agreements: [],
      company_id: parseInt(this.props.match.params.companyId, 10),
      showModal: false,
      goalForm: {
        outcome: '',
        measured: '',
        validation: true
      },
      validation: {},
      error: null,
    };
  }

  validate = () => {
    const validation = {};
    let valid = true;

    if (this.state.sponsor === null) {
      validation.sponsor = 'Required field';
      valid = false;
    }

    if (this.state.goals.length === 0) {
      validation.goals = 'Must add at least one goal.';
      valid = false;
    }

    this.setState({validation});

    return valid;
  };

  saveEngagement = async (event) => {
    event.preventDefault();

    if(this.validate()) {
      const engagement = {
        company_id: this.state.company_id,
        sponsor: this.state.sponsor.id,
        coach: this.state.coach,
        goals: this.state.goals
      };

      try {
        await GreenLeafApi.Engagement.create(engagement);
        this.props.history.push(`/companies/${this.state.company_id}`);
      } catch(e) {
        this.setState({error: e.errors});
      }
    }
  };

  saveContact = async (contact) => {
    contact.company_id = this.props.match.params.companyId;

    try {
      let con = (await GreenLeafApi.Contact.create(contact)).data;
      con.name = con.first_name + ' ' + con.last_name;
      this.setState(prevState => ({
        sponsor: con,
        showModal: false,
      }));
    } catch (e) {
      this.setState({error: e.errors});
    }
  };

  handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    this.setState(prevState => ({
      [name]: value,
      validation: {
        ...prevState.validation,
        [name]: null,
      }
    }));
  };

  handleGoalChange = (event) => {
    const value = event.target.value;
    const name = event.target.name;

    this.setState(prevState => ({
      goalForm: {
        ...prevState.goalForm,
        [name]: value
      },
    }));
  };

  handleContactChange = (contact) => {
    if (contact && !contact.id) {
      this.setState({ showModal: true });
      return;
    }

    this.setState(prevState => ({
      sponsor: contact,
      validation: {
        ...prevState.validation,
        sponsor: null,
      }
    }));
  };

  getContacts = async (input, callback) => {
    if (!input && input.length < 3) {
      return callback(null, { options: [] });
    }

    input = input.split(' ');

    try {
      const options = await GreenLeafApi.Contact.get(
        {
          companyId: this.props.match.params.companyId,
          firstName: `%25${input[0]}%25`,
          lastName: `%25${input[1] ? input[1] : ''}%25`
        });

      options.data.forEach(o => o.name = o.first_name + ' ' + o.last_name);

      callback(null, { options: options.data });
    } catch (e) {
      this.setState({error: e.errors});
    }
  };

  getGoalValidation = () => {
    return { measured: !validator.isEmpty(this.state.goalForm.measured), outcome: !validator.isEmpty(this.state.goalForm.outcome) };
  };

  deleteGoal = (index) => {
    this.setState({
      goals: [...this.state.goals.filter((g, i) => i !== index)]
    });
  };

  addGoal = () => {
    if (this.getGoalValidation().measured && this.getGoalValidation().outcome) {
      this.setState(prevState => ({
        goals: [...prevState.goals, { outcome: this.state.goalForm.outcome, measured: this.state.goalForm.measured }],
        goalForm: { outcome: '', measured: '', validation: true }
      }));
    } else {
      this.setState(prevState => ({
        goalForm: { ...prevState.goalForm, validation: false }
      }));
    }
  };

  render() {

    return (
      <div>
        <EditPage
          title='Propose Engagement'
          isCreating
          error={this.state.error}
        >
          <Fragment>
            {
              this.state.validation.goals &&
                <ErrorComponent error={[ { msg: this.state.validation.goals } ]}/>
            }
            <Form horizontal onSubmit={this.saveEngagement}>
              <FormGroup data-cy={'contact-selector'} validationState={this.state.validation.sponsor ? 'error' : null}>
                <Col xs={2} componentClass={ControlLabel} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                  <p>Sponsor&nbsp;</p><p style={{fontSize: '10px'}}>*</p>
                </Col>
                <Col xs={10}>
                  <Select.AsyncCreatable
                    multi={false}
                    value={this.state.sponsor}
                    onChange={this.handleContactChange}
                    loadOptions={this.getContacts}
                    labelKey="name"
                    valueKey="name"
                  />
                  {this.state.validation.sponsor ? <HelpBlock>{this.state.validation.sponsor}</HelpBlock> : ''}
                </Col>
              </FormGroup>


              <FormGroup validationState={this.state.validation && this.state.validation.email ? 'error' : null} controlId="formHorizontalEmail">
                <Col xs={2} componentClass={ControlLabel}>
                  Coach Email
                </Col>
                <Col xs={10}>
                  <FormControl name="coach" type="text" value={this.state.coach} placeholder="Email" onChange={this.handleChange}/>
                  <FormControl.Feedback/>
                  {this.state.validation.email ? <HelpBlock>{this.state.validation.email}</HelpBlock> : ''}
                </Col>

              </FormGroup>

              <FormGroup validationState={this.state.goalForm.validation ? null : 'error'}>
                <Col xs={2} componentClass={ControlLabel} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                  <p>Goal(s)&nbsp;</p><p style={{fontSize: '10px'}}>*</p>
                </Col>
                <Col xs={10}>
                  <Table>
                    <thead>
                    <tr>
                      <th>#</th>
                      <th>Outcome</th>
                      <th>As measured by</th>
                      <th/>
                    </tr>
                    </thead>
                    <tbody>
                    {
                      this.state.goals.map((goal, i) => {
                        return (
                          <tr key={i}>
                            <td>{+i+1}.</td>
                            <td>{goal.outcome}</td>
                            <td>{goal.measured}</td>
                            <td><Button data-cy={`remove-goal-${i}`} onClick={() => this.deleteGoal(i)}><Glyphicon glyph='remove-sign'/></Button></td>
                          </tr>
                        );
                      })
                    }
                    <tr>
                      <td/>
                      <td>
                        <FormControl data-cy='outcome-field' name='outcome' type="text" value={this.state.goalForm.outcome||''} placeholder="Outcome" onChange={this.handleGoalChange}/>
                        {!this.state.goalForm.validation && !this.getGoalValidation().outcome && <HelpBlock>Required field.</HelpBlock>}
                      </td>
                      <td>
                        <FormControl data-cy='measured-field' name='measured' type="text" value={this.state.goalForm.measured||''} placeholder="As measured by" onChange={this.handleGoalChange}/>
                        {!this.state.goalForm.validation && !this.getGoalValidation().measured && <HelpBlock>Required field.</HelpBlock>}
                      </td>
                      <td><Button data-cy='create-goal' onClick={this.addGoal}><Glyphicon glyph='plus-sign'/></Button></td>
                    </tr>
                    </tbody>
                  </Table>
                </Col>
              </FormGroup>

              <FormGroup>
                <Col xs={12}>
                  <div className='text-right'>
                    <Button data-cy="cancel-engagement-create" className='secondary' onClick={() => this.props.history.push(`/companies/${this.props.match.params.companyId}`)}>Cancel</Button>
                    <Button data-cy="save-engagement" className='ml1 primary' type="submit">Save</Button>
                  </div>
                </Col>
              </FormGroup>

            </Form>
          </Fragment>

        </EditPage>
        { this.state.showModal &&
        <CreateContactModal
          show={this.state.showModal}
          handleClose={() => this.setState({ showModal: false })}
          onSave={this.saveContact}/>
        }
      </div>
    );
  }
}

export default CreateEngagementPage;



// WEBPACK FOOTER //
// ./src/components/engagement/CreateEngagementPage.js